import { Col, Input, Form, Row, Select, Button } from "antd";
import React, { Fragment, useState } from "react";
import { translate } from "react-i18next";
import { compose } from "redux";
import EnhancedModal from "../../../../../../../components/enhanced-modal";
import ItemList from "../../../../../../../components/item-list";
import Selector from "../../../../../../../components/selector";
import { DataLanguageConsumer } from "../../../../../../../contexts/DataLanguage";
import {
  GUTTER_MD, MARGIN_MD, MODAL_WIDTH_LG
} from "../../../../../../../styles/constants";
import { getArtefactTripletFromString } from "../../../../../../../utils/sdmxJson";

const mapPropsToFields = ({ value }) => ({
  name: Form.createFormField({ value: value ? value.name : null }),
  text: Form.createFormField({ value: value 
    ? (value.text || "").length > 0 
      ? value.text 
      : null 
    : null }),
});

  
const CalculatedCondition = ({
  t,
  value,
  form,
  appLanguage,
  components,
  blockIdx,
  onComponentValueDefinitionValueSet,
  componentCodelistCodesItemsPage,
  componentCodelistCodesItemsCount,
  fetchCodelistCodesItemsPage
}) => {

  
  const component = components.find(c => c.name === value.name)
  const componentName = component.name;
 
  const [isCodeSelectorVisible, setCodeSelectorVisible] = useState(false);
  const [codelistCode, setCodelistCode] = useState(component.codelistCode);

  const codelistTriplet = codelistCode ? getArtefactTripletFromString(codelistCode) : null;


  const onSelectChange = (val) => {    
    const component = components.find(c => c.name === val);
    setCodelistCode(component.codelistCode);
    onComponentValueDefinitionValueSet({blockIdx: blockIdx, conditionIdx:value.idx, condition: {name: val, text : ""}});
  }

  const onConditionTextSet = (text) => {    
    setCodeSelectorVisible(false);
    onComponentValueDefinitionValueSet({blockIdx: blockIdx, conditionIdx:value.idx, condition: {name: value.name, text :text}});
  }
  
  return(
    <Fragment>
      <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
        <Col span={11}>
        {form.getFieldDecorator("name")(
          <Select
            style={{width:"100%"}}
            onChange={(val) => onSelectChange(val)}
            showSearch
            filterOption={(inputValue, {props}) =>
                props.title.toLowerCase().includes(inputValue.toLowerCase())
            }
          >
            {components.map((option, index) => (
              <Select.Option
                key={index}
                value={option.name}
                title={option.name}
              >
                {option.name}
              </Select.Option>
            ))}
          </Select>
        )}
        </Col>
        <Col span={2}>
          <Button>
            =
          </Button>
        </Col>
        <Col span={11}>
          {form.getFieldDecorator("text")(
            (codelistCode || "").length > 0 ? 
            (
              <Selector
                onSelect={() => setCodeSelectorVisible(true)}
                onReset={() => onComponentValueDefinitionValueSet({blockIdx: blockIdx, conditionIdx:value.idx, condition: {name: value.name, text : ""}})}
              />
            )
            : (
              
              <Input 
                title={form.getFieldValue("text")}
                onChange={({target}) => onComponentValueDefinitionValueSet({blockIdx: blockIdx, conditionIdx:value.idx, condition: {name: value.name, text : target.value}})}
              />
            )            
            )}
        </Col>
      </Row>

      <EnhancedModal
        visible={isCodeSelectorVisible}
        onCancel={() => setCodeSelectorVisible(false)}
        title={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.valueSelector.title')}
        width={MODAL_WIDTH_LG}        
        withDataLanguageSelector
      >
        <DataLanguageConsumer>   
          {dataLanguage => {
            const language = dataLanguage || appLanguage;
            return (
              <ItemList
                data={componentCodelistCodesItemsPage || null}
                rowCount={componentCodelistCodesItemsCount}
                isPaginated
                onRowClick={item => onConditionTextSet(item.id)}      
                onChange={
                  ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                  fetchCodelistCodesItemsPage({
                      codelistTriplet,
                      language,
                      pageNum,
                      pageSize,
                      searchText,
                      filters,
                      sortCol,
                      sortByDesc,
                      componentName
                    })
                }
              />
            );
          }}     
        </DataLanguageConsumer>
      </EnhancedModal>

</Fragment>
  );     
};

export default compose(
  translate(),
  Form.create({ mapPropsToFields })
)(CalculatedCondition);
